<template>
    <div class="content_box mobile_content">
        <div class="content">
            <div class="title_box">
                <div class="title">
                    <span>标签管理</span>
                </div>
            </div>
            <el-form label-width="100px" ref="formRule">
                <div class="faq_box">
                    <div class="add_faq_box">
                        <div class="add_item" v-for="(item, i) in tags" :key="i + 53543">
                            <el-form-item label="标签名称">
                                <el-input v-model="tags[i]" placeholder="请输入标签名称"></el-input>
                            </el-form-item>
                            <div class="act_box">
                                <i class="el-icon-circle-plus-outline add_faq" @click="addTagsItem(i+1)"></i>
                                <i class="el-icon-delete del_faq" @click="delTagsItem(i)"></i>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="line"></div>
                <el-form-item>
                    <div class="btn">
                        <div class="button" @click="updateConfirm">
                            <span>提交</span>
                        </div>
                        <!-- <div class="button button2" @click="$router.go(-1)">
                            <span>返回</span>
                        </div> -->
                    </div>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>
<script>
export default({
    name: 'community-tag',
    data() {
        return {
            tags: []
        }
    },
    watch: {
    },
    created() {
        this.getTags();
    },
    methods: {
        getTags() {
            this.api.getCommunityTags({}).then(data => {
                if(data.data) {
                    this.tags = data.data.split(',');
                }else{
                    this.tags = [''];
                }
            })
        },
        addTagsItem(i) {
            this.tags.splice(i, 0, '');
        },
        delTagsItem(i) {
            this.tags.splice(i, 1);
        },
        updateConfirm() {
            const tags = this.tags.join(',');
            this.api.communityTagsUpdate({tags: tags}).then(data => {
                this.$message.success('标签保存成功!');
            })
        }
    }
})
</script>
<style lang="less" scoped>
    .el-form{
        max-width: 400px;
        .add_item{
            position: relative;
            .el-form-item{
                margin-bottom: 10px;
            }
            .textarea_item{
                padding-bottom: 10px;
                border-bottom: 1px dashed #999;
            }
            .act_box{
                position: absolute;
                right: -70px;
                top: 3px;
                width: 60px;
                font-size: 20px;
                color: @colorDel;
                cursor: pointer;
                .add_faq{
                    color: @colorBlue;
                    font-size: 22px;
                    margin-right: 10px;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/view/app/community/tag-manage.vue